import styles from './FJDetailsPreviewModal.module.less';
import FJCloseIcon from '../../../../assets/svg/close.svg?react';
import FJPreviewInfoContainer from '../container/FJPreviewInfoContainer.jsx';
import FJMediaPreview from './FJMediaPreview.jsx';
import classNames from 'classnames';
import FJPageUpIcon from '../../../../assets/svg/community/page-up.svg?react';
import FJPageDownIcon from '../../../../assets/svg/community/page-down.svg?react';
import PropTypes from 'prop-types';

const FJDetailsPreviewModal = ({
    onClose,
    active,
    info,
    isActiveNext = true,
    isActivePrevious = true,
    switchPreview,
    onDelete,
    hidePageBox = false,
}) => {
    return (
        <div className={styles.box}>
            <div className={styles.close_btn} onClick={onClose}>
                <div className={styles.inner_icon}>
                    <FJCloseIcon />
                </div>
            </div>
            <div className={styles.left}>
                {active && <FJMediaPreview info={info} />}

                {!hidePageBox && (
                    <div className={styles.page_box}>
                        <div
                            className={classNames(styles.catalog_icon_box, !isActivePrevious ? styles.disable : '')}
                            onClick={() => {
                                switchPreview(false);
                            }}
                        >
                            <FJPageUpIcon />
                        </div>
                        <div
                            className={classNames(styles.catalog_icon_box, !isActiveNext ? styles.disable : '')}
                            onClick={() => {
                                switchPreview(true);
                            }}
                        >
                            <FJPageDownIcon />
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.right}>
                <FJPreviewInfoContainer onDelete={onDelete} />
            </div>
        </div>
    );
};

FJDetailsPreviewModal.propTypes = {
    onClose: PropTypes.func,
    active: PropTypes.bool,
    info: PropTypes.object,
    isActiveNext: PropTypes.bool,
    isActivePrevious: PropTypes.bool,
    switchPreview: PropTypes.func,
    onDelete: PropTypes.func,
    hidePageBox: PropTypes.bool,
};

export default FJDetailsPreviewModal;
